<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card >
        <md-card-content>
          <div class='info_list'>
            <h3 >
              <span>{{$I18n("inv_title")}}</span> 
              <i @click="openModal">{{$I18n("edit")}}</i>
            </h3>
            <div>
                <label>{{$I18n("alias")}}</label>
                <span>{{titleData.name}}</span>
            </div>
            <div>
                <label>{{$I18n("tax_no")}}</label>
                <span>{{titleData.tax_no}}</span>
            </div>
            <div>
                <label>{{$I18n("comp_name")}}</label>
                <span>{{titleData.comp_name}}</span>
            </div>
            <div>
                <label>{{$I18n("company_address")}}</label>
                <span>{{titleData.comp_addr}}</span>
            </div>
            <div>
                <label>{{$I18n("bank_name_02")}}</label>
                <span>{{titleData.bank_name}}</span>
            </div>
            <div>
                <label>{{$I18n("bank_no")}}</label>
                <span>{{titleData.bank_no}}</span>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "$I18n('edit_title')"
      :right = "true"
      :large = "false"
      @submit= "modal_submit"
    >
      <div slot="body">
        <common-form-item 
          v-for="item in form_modalData" 
          v-model="titleModalData.Form[item.keys]" 
          :error="titleModalData.Error[item.keys]" 
          :key="item.keys" v-bind="item"
        ></common-form-item>
      </div>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass,/*timestampToString*/ } from "@/common/tools.js";
export default {
  components: {

  },
  data() {
    return {
      titleData: {},
      titleModalData : new FormClass({
        name  : "",
        tax_no  : "",
        comp_name : "",
        comp_addr : "",
        bank_name : "",
        bank_no : "",
      },{
        name : "required",
        tax_no : "required",
        comp_name : "required",
      }),
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: {},
  computed: {
    form_modalData(){
      return [
        {
          label   : this.$I18n("alias"),
          keys    : "name",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("tax_no"),
          keys    : "tax_no",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("comp_name"),
          keys    : "comp_name",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("company_address"),
          keys    : "comp_addr",
          type    : "input",
        },{
          label   : this.$I18n("bank_name_02"),
          keys    : "bank_name",
          type    : "input",
        },{
          label   : this.$I18n("bank_no"),
          keys    : "bank_no",
          type    : "input",
        },
      ]
    },
  },
  methods: {
    api_getPageData (){
      this.$api.getInvo()
        .then(this.$Then(res => {
          this.titleData = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    openModal (){
      this.$refs.modal.open();
      this.titleModalData.Update(this.titleData);
    },
    // 隐藏 弹窗
    modal_classicModalHide () {
      this.$refs.modal.close()
    },
    // 提交表单
    modal_submit () {
      if(this.titleModalData.Check()){
        this.$errorMsg(this.$I18n("pls_input_content"));
        return
      }
      this.$api.setInvo({
        ...this.titleModalData.Form,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("succ_num"));
          this.modal_classicModalHide();
          this.api_getPageData();
        }))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
  },
}
</script>
<style lang="css" scoped>
  .md-modal-diy /deep/ .md-icon{
    margin-left:  auto !important;
    margin-right: 0!important;
  }
  .modal-loader {
    margin-top: 15px;
    margin-left:30px;
    margin-right:30px;
  }
  .imagebox{
    width: 100%;
    padding:17px 0 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    min-height: 123.500px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .click-upload{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: #30a5ff;
    color: #FFF;
  }
  .modal-loader /deep/ .uploader-drop{
    width: 592px !important;
    /*line-height: 240px;*/
  }
</style>
<style lang="scss" scoped>
  .main-box{
    display: flex;
    width: 100%;
    border-bottom: 0 !important;
  }
  .bala-box{
    margin: 0px 20px;
    display: flex;
    justify-content: center;
  }
  .bala-div{
    padding: 50px 40px;
    line-height: 40px;
    width: 400px;
    border: 4px solid rgb(16,174,255);
    border-radius: 10px;
  }
  .bala-type{
    font-size: 18px;
    font-weight: 600;
    color: #666;
    line-height: 24px;
    position: absolute;
    top: 5px;
    left: 15px;
    padding: 10px;
  }
  .bala-value{
    font-size:20px;
    font-weight: 600;
    text-align: center;
  }
  .bala-history{
    position: absolute;
    bottom: 5px;
    left: 15px;
    padding: 10px;
    font-size: 14px;
    cursor: pointer;
    color: #30a5ff;
  }
  .go-tran{
    position: absolute;
    right: 15px;
    top: 5px;
    cursor:pointer;
    padding: 10px;
    color: #30a5ff;
  }

  /*myInfo.html 单独样式*/
      .info_list {
        margin: 0 24px;
      }
      .info_list>div{
          padding: 10px 0;
          border-bottom: .5px solid #efefef;
          line-height: 24px;
          color: rgba(0,0,0,.85);
          font-family: 'Monospaced';
      }
      .info_list label{
          display: inline-block;
          margin-right: 20px;

          color: #9b9b9b;
          font-weight: 400;
          width: 195px;
      }
      .info_list div span {
          color: #4b4b4b;
          font-weight: 400;
      }
      h3 {
        height: 50px;
        border-radius: 4px 4px 0 0;
        line-height: 50px;
        color: rgba(0,0,0,.65);
        /*border-bottom: 1px solid rgba(0,0,0,.65);*/
        margin-top: 0px;
        font-weight: 600;
        font-size: 16px;
      }
      h4 i, h3 i, .info_list i{
        /*float: right;*/
        color: #30a5ff;
        font-style: inherit;
        font-size: 14px;
        margin-left: 32px;
        cursor: pointer;
      }
  /*myInfo.html 单独样式结束*/
</style>
